/* eslint-disable tailwindcss/no-custom-classname */
import { Br } from "@/components/molecules/Br";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Disclosure } from "@headlessui/react";
import { useState } from "react";

const positions = [
  {
    tag: "engineer_new",
    section: "SE",
    section_sub: "システムエンジニア／新卒",
    terms: [
      {
        label: "業務内容",
        body: "システム要件定義／設計／コーディング／テスト／保守運用など<br class='tbpc'/>使用OS:Linux／Windows／Mac　など<br class='tbpc'/>使用言語：Java,PHP,JavaScript系言語 など",
      },
      {
        label: "勤務地",
        body: "東京（神保町）",
      },
      {
        label: "勤務時間",
        body: "9:00～18:00",
      },
      {
        label: "給与",
        body: "個別にお問い合わせください",
      },
      {
        label: "昇給・賞与",
        body: "昇給随時、賞与年2回（夏季・冬季）",
      },
      {
        label: "休日・休暇",
        body: "完全週休2日制（土・日・祝日）<br class='tbpc'/>夏季休暇・年末年始休暇／慶弔休暇／年次有給休暇",
      },
      {
        label: "待遇・福利厚生",
        body: "各種社会保険完備（東京都情報サービス産業健康保険組合加入）、資格取得支援制度有、試用期間あり（3ヶ月）",
      },
      {
        label: "各種手当",
        body: "通勤、残業、職務、役職、資格",
      },
      {
        label: "応募条件",
        body: "学歴不問、募集対象は卒業後3年以内の方",
      },
    ],
  },
  {
    tag: "engineer_member",
    section: "SE",
    section_sub: "システムエンジニア／メンバー候補",
    terms: [
      {
        label: "業務内容",
        body: "システム要件定義／設計／コーディング／テスト／保守運用など<br class='tbpc'/>使用OS:Linux／Windows／Mac　など<br class='tbpc'/>使用言語：Java,PHP,JavaScript系言語 など",
      },
      {
        label: "勤務地",
        body: "東京（神保町）",
      },
      {
        label: "勤務時間",
        body: "9:00～18:00",
      },
      {
        label: "給与",
        body: "個別にお問い合わせください",
      },
      {
        label: "昇給・賞与",
        body: "昇給随時、賞与年2回（夏季・冬季）",
      },
      {
        label: "休日・休暇",
        body: "完全週休2日制（土・日・祝日）<br class='tbpc'/>夏季休暇・年末年始休暇／慶弔休暇／年次有給休暇",
      },
      {
        label: "待遇・福利厚生",
        body: "各種社会保険完備（東京都情報サービス産業健康保険組合加入）、資格取得支援制度有、試用期間あり（3ヶ月）",
      },
      {
        label: "各種手当",
        body: "通勤、残業、職務、役職、資格",
      },
      {
        label: "応募条件",
        body: "Web開発（システムエンジニア）　実務1年以上<br class='tbpc'/>Java, PHP、JavaScript（ReactやNext.jsなど）のいずれか　実務1年以上",
      },
    ],
  },
  {
    tag: "engineer_leader",
    section: "SE",
    section_sub: "システムエンジニア／リーダー候補",
    terms: [
      {
        label: "業務内容",
        body: "システム要件定義／設計／コーディング／テスト／保守運用／プロジェクト管理（工数管理、スケジュール管理、メンバーサポート）など<br class='tbpc'/>使用OS:Linux／Windows／Mac　など<br class='tbpc'/>使用言語：Java,PHP,JavaScript系言語 など",
      },
      {
        label: "勤務地",
        body: "東京（神保町）",
      },
      {
        label: "勤務時間",
        body: "9:00～18:00",
      },
      {
        label: "給与",
        body: "個別にお問い合わせください",
      },
      {
        label: "昇給・賞与",
        body: "昇給随時、賞与年2回（夏季・冬季）",
      },
      {
        label: "休日・休暇",
        body: "完全週休2日制（土・日・祝日）<br class='tbpc'/>夏季休暇・年末年始休暇／慶弔休暇／年次有給休暇",
      },
      {
        label: "待遇・福利厚生",
        body: "各種社会保険完備（東京都情報サービス産業健康保険組合加入）、資格取得支援制度有、試用期間あり（3ヶ月）",
      },
      {
        label: "各種手当",
        body: "通勤、残業、職務、役職、資格",
      },
      {
        label: "応募条件",
        body: "Web開発（システムエンジニア）　実務3年以上<br class='tbpc'/>Java, PHP、JavaScript（ReactやNext.jsなど）のいずれか　実務3年以上<br class='tbpc'/>リーダー経験orメンバー育成（新人フォロー含む）経験をお持ちの方",
      },
    ],
  },
  {
    tag: "infra",
    section: "SE",
    section_sub: "インフラエンジニア",
    terms: [
      {
        label: "業務内容",
        body: "AWS等のクラウドサービスを用いたWeb環境構築<br class='tbpc'/>開発/運用/性能/セキュリティなどをバランスを考慮し全体最適を考えた基盤構築など",
      },
      {
        label: "勤務地",
        body: "東京（神保町）",
      },
      {
        label: "勤務時間",
        body: "9:00～18:00",
      },
      {
        label: "給与",
        body: "個別にお問い合わせください",
      },
      {
        label: "昇給・賞与",
        body: "昇給随時、賞与年2回（夏季・冬季）",
      },
      {
        label: "休日・休暇",
        body: "完全週休2日制（土・日・祝日）<br class='tbpc'/>夏季休暇・年末年始休暇／慶弔休暇／年次有給休暇",
      },
      {
        label: "待遇・福利厚生",
        body: "各種社会保険完備（東京都情報サービス産業健康保険組合加入）、資格取得支援制度有、試用期間あり（3ヶ月）",
      },
      {
        label: "各種手当",
        body: "通勤、残業、職務、役職、資格",
      },
      {
        label: "応募条件",
        body: "Web開発（システムエンジニア）　実務3年以上<br class='tbpc'/>AWSを用いたインフラ経験　実務3年以上",
      },
    ],
  },
  {
    tag: "webDesigner",
    section: "Webデザイナー",
    terms: [
      {
        label: "業務内容",
        body: "Webサイトのデザイン制作<br class='tbpc'/>使用ソフト・言語: HTML, CSS, Illustrator, Photoshop, VSCodeなど",
      },
      {
        label: "勤務地",
        body: "東京（神保町）",
      },
      {
        label: "勤務時間",
        body: "9:00～18:00",
      },
      {
        label: "給与",
        body: "個別にお問い合わせください",
      },
      {
        label: "昇給・賞与",
        body: "昇給随時、賞与年2回（夏季・冬季）",
      },
      {
        label: "休日・休暇",
        body: "完全週休2日制（土・日・祝日）<br class='tbpc'/>夏季休暇・年末年始休暇／慶弔休暇／年次有給休暇",
      },
      {
        label: "待遇・福利厚生",
        body: "各種社会保険完備（東京都情報サービス産業健康保険組合加入）、資格取得支援制度有、試用期間あり（3ヶ月）",
      },
      {
        label: "各種手当",
        body: "通勤、残業、職務、役職、資格",
      },
      {
        label: "応募条件",
        body: "学歴不問、実務経験者優遇",
      },
    ],
  },
  {
    tag: "sales",
    section: "営業職",
    terms: [
      {
        label: "業務内容",
        body: "システム開発／システム構築／パッケージ・サービス販売／コンテンツ制作等の企画・営業",
      },
      {
        label: "勤務地",
        body: "東京（神保町）",
      },
      {
        label: "勤務時間",
        body: "9:00～18:00",
      },
      {
        label: "給与",
        body: "個別にお問い合わせください",
      },
      {
        label: "昇給・賞与",
        body: "昇給随時、賞与年2回（夏季・冬季）",
      },
      {
        label: "休日・休暇",
        body: "完全週休2日制（土・日・祝日）<br class='tbpc'/>夏季休暇・年末年始休暇／慶弔休暇／年次有給休暇",
      },
      {
        label: "待遇・福利厚生",
        body: "各種社会保険完備（東京都情報サービス産業健康保険組合加入）、資格取得支援制度有、試用期間あり（3ヶ月）",
      },
      {
        label: "各種手当",
        body: "通勤、残業、職務、役職、資格",
      },
      {
        label: "応募条件",
        body: "学歴不問、実務経験者優遇",
      },
    ],
  },
];

const CareerPosition = () => {
  const [open, setOpen] = useState(false);
  return (
    <div id="position" className="--offset">
      <div className="relative mx-auto box-border max-w-7xl px-8 font-bold md:px-20 ">
        <div className="space-y-4 md:space-y-8">
          <div className="space-y-2 md:space-y-1">
            <h2 className=" text-ter fluid-text-[11px,16px]">募集ポジション</h2>
            <h3 className=" text-ter fluid-text-[18px,26px]">Position</h3>
          </div>
          <div className="flex flex-col gap-2 md:gap-4">
            {positions.map((position) => (
              <Disclosure key={position.tag}>
                {({ open }) => (
                  <div>
                    <Disclosure.Button className="group flex w-full items-center justify-center border border-solid border-bdc-light py-6 hover:border-hov/30 md:py-8">
                      <h5 className="mr-4 flex items-center font-bold text-pri fluid-text-[16px,22px] group-hover:text-hov">
                        {position.section}
                        {position.section_sub && (
                          <span className="ml-2 text-xs md:text-sm">
                            （{position.section_sub}）
                          </span>
                        )}
                      </h5>
                      <FontAwesomeIcon
                        icon={faPlus}
                        className={`${
                          open
                            ? "rotate-45 text-lg text-pri"
                            : "text-lg text-icn group-hover:text-hov"
                        }`}
                      />
                    </Disclosure.Button>
                    <Disclosure.Panel className="py-5 md:pt-10">
                      <div className="grid grid-cols-1 gap-4 md:grid-cols-4 md:gap-14">
                        <div className="col-span-1 font-bold text-txt-light">
                          {position.section}
                          {position.section_sub && (
                            <span className="text-xs">
                              （{position.section_sub}）
                            </span>
                          )}
                          <Br pc />
                          募集要項
                        </div>
                        <div className="col-span-3 flex flex-col divide-y divide-solid divide-bdc-light border-x-0 border-y border-solid border-bdc-light text-base text-txt-base">
                          {position.terms.map(function (term) {
                            return (
                              <dl
                                key={term.label}
                                className="grid grid-cols-1 border-x-0 py-2 md:grid-cols-4 md:py-4"
                              >
                                <dt className="col-span-1 text-txt-light fluid-text-[12px,16px]">
                                  {term.label}
                                </dt>
                                <dd className="col-span-3 font-normal leading-relaxed fluid-text-[14px,18px]">
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: `${term.body}`,
                                    }}
                                  />
                                </dd>
                              </dl>
                            );
                          })}
                        </div>
                      </div>
                    </Disclosure.Panel>
                  </div>
                )}
              </Disclosure>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerPosition;
